import { Host, h } from '@stencil/core';
import { store as PesRouterStore } from './pes-router-store';
import parseUrl from './pes-route-parser';
export class PesRouter {
  constructor() {
    this.navigation = 'path';
    this.base_dir = '';
    this.store = PesRouterStore;
  }
  setNavigation() {
    this.setupRouterState();
  }
  setBaseDir() {
    this.setupRouterState();
  }
  setupRouterState() {
    const route = parseUrl(this.navigation, this.base_dir);
    this.store.set('usePesRouter', true);
    this.store.set('navigation', this.navigation);
    for (const [key, value] of Object.entries(route)) {
      this.store.set(key, value);
    }
  }
  componentWillLoad() {
    this.setupRouterState();
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
  static get is() { return "pes-router"; }
  static get properties() {
    return {
      "navigation": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "PesNavigationType",
          "resolved": "\"event\" | \"hash\" | \"path\"",
          "references": {
            "PesNavigationType": {
              "location": "import",
              "path": "../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Navigation type to parse url."
        },
        "attribute": "navigation",
        "reflect": false,
        "defaultValue": "'path'"
      },
      "base_dir": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "'base/dir' for http://some.com/base/dir/WW/en or http://some.com/route/#/base/dir/WW/en."
            }, {
              "name": "example",
              "text": "'base_dir' for http://some.com/base_dir/WW/en or http://some.com/#/base_dir/WW/en."
            }, {
              "name": "example",
              "text": "''         for http://some.com/WW/en          or http://some.com/#/WW/en."
            }],
          "text": "Part of url between domain (or hash #) and route parameters.\nDon't use leading and trailing slash."
        },
        "attribute": "base_dir",
        "reflect": false,
        "defaultValue": "''"
      },
      "store": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ObservableMap<PesRouterState>",
          "resolved": "ObservableMap<PesRouterState>",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The instance of the stencil store."
        },
        "defaultValue": "PesRouterStore"
      }
    };
  }
  static get watchers() {
    return [{
        "propName": "navigation",
        "methodName": "setNavigation"
      }, {
        "propName": "base_dir",
        "methodName": "setBaseDir"
      }];
  }
}
